import { AuthDispatchContext } from "@context/AuthContext";
import useApiHook from "@hooks/useApiHook";
import routes from "@routes/routes";
import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "@axios/axiosInstance";
import useApiError from "@hooks/useApiError";
import { UserDispatchContext } from "@context/UserContext";
import useNotification from "./useNotification";
import Cookies from "js-cookie";
import { EpisodesContext } from "@src/context/EpisodesContext";
import { TotalItemsDispatchContext } from "@src/context/TotalItemsContext";
import { CardsDisptchContext } from "@src/context/CardsContext";
import { ChangeEmailContext } from "@src/context/ChangeEmailContext";
import { useQueryClient } from "@tanstack/react-query";

const useLogout = () => {
  const setApiError = useApiError();
  const navigate = useNavigate();
  const userDispatch = useContext(UserDispatchContext);
  const setCards = useContext(CardsDisptchContext);
  const { setEpisodes } = useContext(EpisodesContext);
  const totalCartItemsDispatch = useContext(TotalItemsDispatchContext);
  const { setEmailData } = useContext(ChangeEmailContext);
  const authDispatchContext = useContext(AuthDispatchContext);
  const queryClient = useQueryClient();
  const flashNotification = useNotification();

  const logoutApi = useApiHook({ method: "delete", url: "/users/sign_out" });

  const logout = useCallback(async () => {
    try {
      const res = await logoutApi<{ status: boolean; message: string }>();
      if (res && res.data.status === true) {
        delete axios.defaults.headers.common["Authorization"];
        if (Cookies.get("aT")) {
          Cookies.remove("aT");
          Cookies.remove("jwt_refresh_token");
          Cookies.remove("rT");
          Cookies.remove("UIDT");
          localStorage.removeItem("count");
          localStorage.setItem("rememberMe", "false");
        }
        setEmailData({
          type: "changeEmail",
          payload: { email: "", password: "" },
        });
        flashNotification({ status: true, message: res.data.message });
        authDispatchContext({ type: "update", payload: false });
        setCards({
          type: "setCards",
          payload: [],
        });
        queryClient.clear(); // this will clear all the queries and mutations.
        userDispatch({ type: "setUser", payload: null });
        setEpisodes({ type: "updateEpisodes", payload: {} });
        // this is for guest user
        totalCartItemsDispatch({
          payload: 0,
          type: "setTotalCount",
        });
        setTimeout(() => {
          navigate(routes.default);
        }, 300);
      }
    } catch (e: any) {
      setApiError(e);
    }
  }, [
    authDispatchContext,
    logoutApi,
    navigate,
    setApiError,
    userDispatch,
    flashNotification,
    setEpisodes,
    totalCartItemsDispatch,
    setEmailData,
    setCards,
    queryClient,
  ]);
  return logout;
};

export default useLogout;
